import React, { useState, useEffect } from "react";
import { Modal, Grid, Card, Feed, Label, Table, Icon, Segment, Popup } from "semantic-ui-react";
import { Line, Bubble } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import { getFormattedTimeFromSeconds } from "utils/dateUtils";
import * as _ from "lodash";
import SupportedFoldersContent from "./SupportedFoldersModal";

const styles = {
	icon: { color: "#fff", fontSize: "1.5em" },
	dateText: { color: "rgb(67, 179, 158)", marginRight: 5, marginLeft: 5 },
};
const waitingTimeOptions = [6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18];

const options = {};
options.scales = {};
options.scales.yAxes = [
	{
		type: "linear",
		display: true,
		position: "left",
		id: "y-axis-1",
	},
	{
		type: "linear",
		display: true,
		position: "right",
		id: "y-axis-2",
	},
];

const StatsFolderHelpModal = ({ open, close, stats, getStats, getSecSupport, closeSecSupport, supportedFolders }) => {
	const [orderFoldersCenters, setOrderFoldersCenters] = useState("tvsec");
	const [directionFoldersCenters, setDirectionFoldersCenters] = useState("ascending");
	const [dataFoldersCenters, setDataFoldersCenters] = useState(null);
	const [orderFoldersSec, setOrderFoldersSec] = useState("count");
	const [directionFoldersSec, setDirectionFoldersSec] = useState("descending");
	const [dataFoldersSecretaries, setDataFoldersSecretaries] = useState(null);
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [secIdForSupportedFolders, setSecIdForSupportedFolders] = useState(null);

	useEffect(() => {
		setDataFoldersCenters(getDataByCenter());
		setDataFoldersSecretaries(getDataBySec());
	}, [stats]);

	const getDataByCenter = () =>
		stats && stats.infoFoldersByCenters && stats.infoFoldersByCenters.length > 0
			? [...stats.infoFoldersByCenters]
					.map((center) => {
						return {
							center: center.name,
							nbFolders: parseInt(center.countTotal),
							tvsec: center.countTotal > 0 ? Math.floor((parseInt(center.countTvSec) / parseInt(center.countTotal)) * 100) : -1,
						};
					})
					.sort((a, b) => b.tvsec - a.tvsec)
			: [];
	const getDataBySec = () =>
		stats && stats.infoSupportToday && stats.infoSupportToday.length > 0
			? [...stats.infoSupportToday]
					.sort((a, b) => b.count - a.count)
					.map((sec) => {
						return {
							id: sec.id,
							secretary: `${sec.first_name} ${sec.last_name}`,
							count: parseInt(sec.count),
							time: parseInt(sec.meanTime),
							total: parseInt(sec.totalTime),
						};
					})
			: [];
	const changeOrder = (order) => {
		if (orderFoldersCenters === order) {
			changeDirection();
			setDataFoldersCenters(dataFoldersCenters.reverse());
		} else {
			setOrderFoldersCenters(order);
			if (order === "tvsec") {
				setDataFoldersCenters(_.sortBy(dataFoldersCenters, (a) => a.tvsec));
			} else if (order === "nbFolders") {
				setDataFoldersCenters(_.sortBy(dataFoldersCenters, (a) => a.nbFolders));
			} else setDataFoldersCenters(_.sortBy(dataFoldersCenters, [order]));
		}
	};
	const changeDirection = () => {
		if (directionFoldersCenters === "ascending") {
			setDirectionFoldersCenters("descending");
		} else {
			setDirectionFoldersCenters("ascending");
		}
	};

	const changeOrderSec = (order) => {
		if (orderFoldersSec === order) {
			changeDirectionSec();
			setDataFoldersSecretaries(dataFoldersSecretaries.reverse());
		} else {
			setOrderFoldersSec(order);
			setDataFoldersSecretaries(_.sortBy(dataFoldersSecretaries, [order]));
		}
	};
	const changeDirectionSec = () => {
		if (directionFoldersSec === "ascending") {
			setDirectionFoldersSec("descending");
		} else {
			setDirectionFoldersSec("ascending");
		}
	};
	const closeAndReset = () => {
		setStartDate(new Date());
		setEndDate(new Date());
		close();
	};

	const getBubbleMeanWaitingTime = (stats) => {
		return {
			labels: waitingTimeOptions,
			datasets: [
				{
					label: "Temps d'attente moyen",
					data: stats
						? waitingTimeOptions.map(
								(wtop) =>
									stats
										.filter((s) => (parseInt(s.min) === 30 ? parseFloat(s.hour + ".5") === wtop : parseInt(s.hour) === wtop))
										.map((s) => parseInt(s.infoTime))
										.reduce((a, b) => a + b, 0) /
									(stats.filter((s) => (parseInt(s.min) === 30 ? parseFloat(s.hour + ".5") === wtop : parseInt(s.hour) === wtop)).length > 0
										? stats.filter((s) => (parseInt(s.min) === 30 ? parseFloat(s.hour + ".5") === wtop : parseInt(s.hour) === wtop)).length
										: 1)
						  )
						: [],
					backgroundColor: "rgb(255, 99, 132)",
					yAxisID: "y-axis-1",
				},
				{
					label: "Nombre de dossiers",
					data: waitingTimeOptions.map(
						(wtop) => stats.filter((s) => (parseInt(s.min) === 30 ? parseFloat(s.hour + ".5") === wtop : parseInt(s.hour) === wtop)).length
					),
					backgroundColor: "rgb(54, 162, 235)",
					yAxisID: "y-axis-2",
				},
			],
		};
	};

	return (
		<Modal closeIcon open={open} closeOnEscape closeOnDimmerClick onClose={closeAndReset} size="large">
			<Modal.Header style={{ backgroundColor: "rgb(67, 179, 158)" }}>
				<div
					style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", color: "white", backgroundColor: "rgb(67, 179, 158)" }}
				>
					<div>Télésecrétariat : Statistiques </div>
					<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "baseline", fontSize: "0.8em" }}>
						<Icon name="calendar alternate" style={styles.icon} />
						Du{" "}
						<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
							<DatePicker
								selected={new Date(startDate)}
								className="datePicker"
								onChange={(date) => {
									setStartDate(date);
									getStats(date, endDate);
								}}
								shouldCloseOnSelect={true}
								dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
							/>
						</div>
						<div> au </div>
						<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
							<DatePicker
								selected={new Date(endDate)}
								className="datePicker"
								onChange={(date) => {
									setEndDate(date);
									getStats(startDate, date);
								}}
								shouldCloseOnSelect={true}
								dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
							/>
						</div>
					</div>
				</div>
			</Modal.Header>
			<Modal.Content>
				<Grid>
					<Grid.Row>
						{stats.statsItems && (
							<Grid.Column mobile={16} tablet={16} computer={8} style={{ overflowY: "auto" }}>
								<Segment className="card-chart">
									<h5 className="card-details">Dossiers du télésecrétariat</h5>
									<Card.Content>
										<div className="chart-zone">
											<Line data={JSON.parse(JSON.stringify(stats.statsItems))} />
										</div>
									</Card.Content>
								</Segment>
							</Grid.Column>
						)}
						{stats.waitingTime && (
							<Grid.Column mobile={16} tablet={16} computer={8} style={{ overflowY: "auto" }}>
								<Segment className="card-chart">
									<h5 className="card-details">Temps d’attente moyen sur la journée</h5>
									<Card.Content>
										<div className="chart-zone">
											<Line
												data={getBubbleMeanWaitingTime(
													stats && stats.waitingTime && stats.waitingTime.length > 0 ? JSON.parse(JSON.stringify(stats.waitingTime)) : []
												)}
												options={options}
											/>
										</div>
									</Card.Content>
								</Segment>
							</Grid.Column>
						)}
						<Card.Group>
							<Card style={{ width: "277px" }}>
								<Card.Content>
									<Card.Header>
										Temps moyen<span style={{ float: "right" }}>{getFormattedTimeFromSeconds(stats.waitingTimeToday)}</span>
									</Card.Header>
								</Card.Content>
								<Card.Content>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={getFormattedTimeFromSeconds(stats.waitingTimeBeforeSupport)}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													minWidth: "135px",
													borderRadius: "20px",
													textAlign: "center",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>avant prise en charge.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={getFormattedTimeFromSeconds(stats.waitingTimeSupport)}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													minWidth: "135px",
													borderRadius: "20px",
													textAlign: "center",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>durant l'intervention.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={getFormattedTimeFromSeconds(stats.waitingTimeForNurse)}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													minWidth: "135px",
													borderRadius: "20px",
													textAlign: "center",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>avant la reprise du dossier par la préleveuse.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={getFormattedTimeFromSeconds(stats.waitingTimeForDocument)}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													minWidth: "135px",
													borderRadius: "20px",
													textAlign: "center",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>période d'initialisation du document scanné.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
								</Card.Content>
							</Card>
							<Card style={{ width: "277px" }}>
								<Card.Content>
									<Card.Header>
										Nombre de dossiers<span style={{ float: "right" }}>{stats.totalFoldersCreatedToday}</span>
									</Card.Header>
								</Card.Content>
								<Card.Content>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersNotDoneToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>en cours actuellement</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersDoneToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>traités durant la période</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersCloseToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>terminés durant la période</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersCanceledToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>annulés par une préleveuse durant la période</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersCanceledBySecToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>annulés par une secrétaire durant la période</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.totalFoldersAbortedToday}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>support annulé par une secrétaire durant la période</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={stats.moreThanOneTvSec}
												style={{
													border: "4px solid rgb(67, 179, 158)",
													borderRadius: "20px",
													textAlign: "center",
													width: "auto",
													fontSize: "20px",
													padding: "12px",
												}}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers passés plus d'une fois au secrétariat</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
								</Card.Content>
							</Card>

							{stats.infoSupportToday && stats.infoSupportToday.length > 0 && (
								<Card style={{ width: "auto" }}>
									<Card.Content>
										<Card.Header>
											Prises en charge par secrétaire<span style={{ float: "right" }}>{stats.infoSupportToday.length}</span>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Table sortable celled fixed>
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell
														sorted={orderFoldersSec === "secretary" ? directionFoldersSec : null}
														onClick={() => changeOrderSec("secretary")}
													>
														Secrétaire
													</Table.HeaderCell>
													<Table.HeaderCell sorted={orderFoldersSec === "count" ? directionFoldersSec : null} onClick={() => changeOrderSec("count")}>
														Nombre de dossiers
													</Table.HeaderCell>
													<Table.HeaderCell sorted={orderFoldersSec === "time" ? directionFoldersSec : null} onClick={() => changeOrderSec("time")}>
														Temps moyen par dossier
													</Table.HeaderCell>
													<Table.HeaderCell sorted={orderFoldersSec === "time" ? directionFoldersSec : null} onClick={() => changeOrderSec("time")}>
														Temps total au support
													</Table.HeaderCell>
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{dataFoldersSecretaries &&
													dataFoldersSecretaries.map((data) => (
														<>
															<Table.Row key={`sec-folder${data.secretary}`}>
																<Table.Cell
																	onClick={() => {
																		setSecIdForSupportedFolders(data.id);
																		getSecSupport(data.id, startDate, endDate);
																	}}
																>
																	{data.secretary}
																</Table.Cell>
																<Table.Cell>{data.count}</Table.Cell>
																<Table.Cell>
																	<Label>{getFormattedTimeFromSeconds(data.time)}</Label>
																</Table.Cell>
																<Table.Cell>
																	<Label>{getFormattedTimeFromSeconds(data.total)}</Label>
																</Table.Cell>
															</Table.Row>
															{secIdForSupportedFolders && data.id === secIdForSupportedFolders && (
																<Table.Row positive>
																	<Table.Cell colSpan="4">
																		<SupportedFoldersContent
																			supportedFolders={supportedFolders}
																			secretary={data.secretary}
																			onClose={() => {
																				closeSecSupport();
																				setSecIdForSupportedFolders(null);
																			}}
																		/>
																	</Table.Cell>
																</Table.Row>
															)}
														</>
													))}
											</Table.Body>
										</Table>
									</Card.Content>
								</Card>
							)}
							{stats.infoAbortedToday && stats.infoAbortedToday.length > 0 && (
								<Card style={{ width: "568px" }}>
									<Card.Content>
										<Card.Header>
											Annulation de prises en charge par secrétaire<span style={{ float: "right" }}>{stats.infoAbortedToday.length}</span>
										</Card.Header>
									</Card.Content>
									<Card.Content>
										{stats.infoAbortedToday.map((user) => (
											<Feed key={`aborted-user${user.id}`}>
												<Feed.Event>
													<Feed.Summary>
														{user.first_name} {user.last_name} <Label>{user.count}</Label>
													</Feed.Summary>
												</Feed.Event>
											</Feed>
										))}
									</Card.Content>
								</Card>
							)}
							{stats.infoFoldersByCenters && stats.infoFoldersByCenters.length > 0 && (
								<Card style={{ width: "568px" }}>
									<Card.Content>
										<Card.Header>
											Nombre de dossiers créés par centre <br />
										</Card.Header>
									</Card.Content>
									<Card.Content>
										<Table sortable celled fixed>
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell
														sorted={orderFoldersCenters === "center" ? directionFoldersCenters : null}
														onClick={() => changeOrder("center")}
													>
														Centre
													</Table.HeaderCell>
													<Table.HeaderCell
														sorted={orderFoldersCenters === "tvsec" ? directionFoldersCenters : null}
														onClick={() => changeOrder("tvsec")}
													>
														% Télésecrétariat
													</Table.HeaderCell>
													<Table.HeaderCell
														sorted={orderFoldersCenters === "folders" ? directionFoldersCenters : null}
														onClick={() => changeOrder("nbFolders")}
													>
														Total dossiers
													</Table.HeaderCell>
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{dataFoldersCenters &&
													dataFoldersCenters.map((data) => (
														<Table.Row key={`centers-folder${data.center}`}>
															<Table.Cell>{data.center}</Table.Cell>
															<Table.Cell>
																{data.nbFolders > 0 && <Label style={{ padding: "2px 8px", marginRight: "8px" }}>{data.tvsec}%</Label>}
															</Table.Cell>
															<Table.Cell>
																<Label color={data.nbFolders > 0 ? "teal" : "black"} style={{ padding: "2px 8px", marginLeft: "10px" }}>
																	{data.nbFolders > 0 ? `${data.nbFolders} dossier${data.nbFolders > 1 ? "s" : ""}` : "Pas de dossier créé"}
																</Label>
															</Table.Cell>
														</Table.Row>
													))}
											</Table.Body>
										</Table>
									</Card.Content>
								</Card>
							)}
						</Card.Group>
					</Grid.Row>
				</Grid>
			</Modal.Content>
			<Modal.Actions>
				<SecondaryBlueButton negative onClick={() => close()}>
					Fermer
				</SecondaryBlueButton>
			</Modal.Actions>
		</Modal>
	);
};

export default StatsFolderHelpModal;
